const DIRECT_FOREGROUND_PATTERNS = [
  /\b(?:show|tell)\s+me\s+where\b/i,
  /\bpoint\s+(?:me\s+)?(?:at|to)\s+(?:this|that|it|here|there|the|a|an)\b/i,
  /\b(?:highlight|circle)\s+(?:this|that|where|here|it)\b/i,
  /\b(?:click|drag|scroll)\s+(?:this|that|the|it|here|there|up|down|left|right)\b/i,
  /\b(?:on|in)\s+(?:my|the|this)\s+(?:screen|desktop|window|app|page)\b/i,
  /\b(?:in\s+the\s+foreground|while\s+i\s+watch|so\s+i\s+can\s+watch)\b/i,
  /\bguide\s+me\s+(?:on|through)\b/i,
] as const;

const SCREEN_OBJECT_PATTERN =
  /\b(?:button|menu|field|input|tab|icon|link|panel|window|screen|desktop|page|dialog|popover|dropdown|setting|control|card|row|column)\b/i;

const SCREEN_ACTION_PATTERN = /\b(?:point|highlight|circle|click|drag|scroll)\b/i;
const IMPERATIVE_SCREEN_ACTION_PATTERN =
  /^\s*(?:please\s+)?(?:point|highlight|circle|click|drag|scroll)\b/i;
const SCREEN_LOOKUP_PATTERN =
  /\b(?:show\s+me|where\s+is|where['’]s|point\s+(?:me\s+)?to)\b/i;
const NEGATED_FOREGROUND_PATTERN =
  /\b(?:do\s+not|don['’]?t|dont|never|without|not)\b[^.!?]{0,80}\b(?:foreground|screen|desktop|window|app|page|look|show|point|highlight|circle|click|drag|scroll)\b/i;

/**
 * True only when the user's words explicitly request visible, spatial desktop
 * guidance or operation. This gate authorizes pre-dispatch screenshot capture,
 * so broad requests such as "show me a recipe" or "draw a logo" must remain
 * false unless they also identify a screen object or foreground context.
 */
export function requestsForegroundScreenContext(text: string): boolean {
  const normalized = text.trim();
  if (!normalized) return false;
  if (NEGATED_FOREGROUND_PATTERN.test(normalized)) return false;
  if (DIRECT_FOREGROUND_PATTERNS.some((pattern) => pattern.test(normalized))) {
    return true;
  }
  if (
    IMPERATIVE_SCREEN_ACTION_PATTERN.test(normalized) &&
    SCREEN_ACTION_PATTERN.test(normalized) &&
    SCREEN_OBJECT_PATTERN.test(normalized)
  ) {
    return true;
  }
  return (
    SCREEN_OBJECT_PATTERN.test(normalized) &&
    SCREEN_LOOKUP_PATTERN.test(normalized)
  );
}
